import React from 'react';
import AltNavbar from '../../components/altNavbar/AltNavbar';
import Hero from '../../containers/hero/Hero';
import ListCard from '../../components/listCard/ListCard';
import GalleryContainer from '../../containers/galleryContainer/GalleryContainer';
import Downloads from '../../containers/downloads/Downloads';

import header2017 from '../../assets//2017/2017header.webp';
import img2017 from './images17';
import highlight17 from '../../assets/2017/17highlights.pdf';

const listItems = [
  {
    text: '為增進香港青少年對祖國的認識，充分了解「一帶一路」發展所帶來的機遇，值香港回歸祖國 20 周年，「一國兩制」獲得巨大成功，香港的社會和經濟發展都取得一定成績。同時，祖國發展一日千里，處處充滿商機。本會一直支持香港青少年關心和瞭解國家的歷史、文化以及日新月異的成就，希望他們積極投身兩地的經濟文化建設，抓住祖國騰飛的機遇，實現自身價值，同時積極貢獻社會，促進共融、達至共贏。',
    image: img2017.img1,
  },
  {
    text: '是故，本會舉辦以「成就．機遇」為主題的交流團。在中央政府駐港聯絡辦、香港特區政府、浙江省政府及浙江海外聯誼會的支持下，舉行「四海一家．浙港舟山交流團」。組織年齡介乎15-35歲的香港青少年前赴浙江交流，進行體驗式學習考察，感受浙江省不同地區的文化和發展。',
    image: img2017.img3,
  },
  {
    text: '浙江是「吳越文化」的發源地，素有「絲綢之府」、「魚米之鄉」和「文化之邦」等美譽。同時，浙江亦是中國各省、區中經濟發展最平衡、最快的省份之一，在信息、環保、健康、旅遊、時尚、金融、高端裝備製造業等七大產業都有顯著成就，其中民營企業更是發展蓬勃。',
    image: img2017.img8,
  },
];

const images2019 = [
  { img: img2017.img1 },
  { img: img2017.img2 },
  { img: img2017.img3 },
  { img: img2017.img4 },
  { img: img2017.img5 },
  { img: img2017.img6 },
  { img: img2017.img7 },
  { img: img2017.img8 },
  { img: img2017.img9 },
  { img: img2017.img10 },
  { img: img2017.img11 },
  { img: img2017.img12 },
  { img: img2017.img13 },
  { img: img2017.img14 },
  { img: img2017.img15 },
];

const Event17 = () => {
  return (
    <div>
      <AltNavbar />
      <Hero image={header2017} />
      {listItems.map((listItem, i) => (
        <ListCard
          key={'list-' + i}
          image={listItem.image}
          heading={listItem.heading}
          text={listItem.text}
        />
      ))}
      <GalleryContainer images={images2019} />
      <Downloads hasReport={false} highlightLink={highlight17} />
    </div>
  );
};

export default Event17;
